module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4V4WG"))).then(() => parcelRequire('fThBo'));